module.exports = __webpack_public_path__ + "static/bosley-logo-c04eccd3500697c1e20388dd6a185813.png";